import { RemoteData } from './RemoteData';
import { Observable } from 'rxjs';

export interface IHttp {
    get<T>(path: string, queryParams?: any): Promise<T>
    post<T>(path: string, data: any): Promise<T>                
}

export interface IRxHttp extends IHttp {
    getObs<T>(path: string, queryParams?: any): Observable<T>
    postObs<T>(path: string, data: any): Observable<T>
    //cancel<T>(): Observable<RemoteData<T>>    

    getRemoteData<T>(path: string, queryParams?: any): Observable<RemoteData<T>>
    postRemoteData<T>(path: string, data: any): Observable<RemoteData<T>>
}

export interface ModelState {
    title: string
    status: number
    errors: {
        [K: string]: string[]
    }
}

export function isModelState(x: any): x is ModelState {
    return x
        && x.type === 'https://tools.ietf.org/html/rfc7231#section-6.5.1'
        && x.errors;
}